'use strict';

let debounce = require('lodash/debounce');
let endpoint;

const searchTriggerEnum = {
    INPUT: 'INPUT',
    BUTTON: 'BUTTON'
};

const emailPattern = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,7}\b/;

// Function to check if the string contains an email pattern
function containsEmail (searchString) {
    return emailPattern.test(searchString);
}

function validateInput (event) {
    if (event.key === 'Enter') {
        let isEmail = containsEmail($('.search-field').val());
        if (isEmail) {
            event.preventDefault();
        }
    }
}

/**
 * Checks if search-overlay is open
 *
 * @return {JQuery} - Boolean
 */
function isSearchOpen () {
    return $('#search-overlay').hasClass('search-is-open');
}

/**
 * Opens the #search-overlay
 *
 * @return {JQuery} - Boolean
 */
function openSearch () {
    $('.site-search').show();
    var searchOverlayHeight = $('#search-overlay').height();
    $('#search-overlay').css('top', '-' + searchOverlayHeight + 'px');
    setTimeout(() => {
        $('.site-search').css({'opacity': '1', 'transition': 'opacity 0.1s ease', 'z-index': '902'});
        $('#search-overlay').animate({ top: '0px', opacity: '1'});
    }, 100);
    $('#search-overlay').addClass('search-is-open');
    $('body').css('overflow', 'hidden');
}

/**
 * Closes the #search-overlay
 *
 * @return {JQuery} - Boolean
 */
function closeSearch () {
    $('#search-overlay').animate({top: '-' + $('#search-overlay').height() + 'px', opacity: '0'});
    setTimeout(() => {
        $('.site-search').css({'opacity': '0', 'transition': 'opacity 0.1s ease', 'z-index': '0'});
        setTimeout(() => {
            $('.site-search').hide();
        }, 200);
    }, 100);
    $('#search-overlay').removeClass('search-is-open');
    $('body').css('overflow', '');
}

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper () {
    return $('#search-overlay').find('.suggestions-wrapper');
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse (response, searchTrigger = searchTriggerEnum.INPUT) {
    let $suggestionsWrapper = getSuggestionsWrapper();
    if (searchTrigger === searchTriggerEnum.BUTTON) {
        $suggestionsWrapper.find('.products-container').empty();
    } else {
        $suggestionsWrapper.empty();
    }

    if (!(typeof (response) === 'object')) {
        if (searchTrigger === searchTriggerEnum.BUTTON) {
            $suggestionsWrapper.find('.products-container').replaceWith(response).show();
        } else {
            $suggestionsWrapper.append(response).show();
        }
    } else {
        $suggestionsWrapper.hide();
    }
}

/**
 * Retrieve suggestions
 *
 * @param {Object} searchTerms - String to get suggestions for
 * @param {Object} searchTriggerEnum - Enum representing the element that triggered the search (INPUT/BUTTON)
 * @param {Object} isMobileSearch - Boolean representing if the search is from mobile or not
 */
function getSuggestions (searchTerms, searchTrigger = searchTriggerEnum.INPUT, isMobileSearch = false) {
    if (containsEmail(searchTerms)) {
        return;
    }
    if (searchTerms.length >= 0) {
        $.ajax({
            context: $('#search-overlay input.search-field'),
            url: endpoint + encodeURIComponent(searchTerms) + '&searchTrigger=' + encodeURIComponent(searchTrigger) + '&isMobileSearch=' + encodeURIComponent(isMobileSearch),
            method: 'GET',
            success: function (response) {
                processResponse(response, searchTrigger);
                $('body').trigger('search:productsSuggestions', { response });
            },
            error: function () { }
        });
    }
}

export default function () {
    endpoint = $('.suggestions-wrapper').data('url');
    var isMobileSearch = $('.search-toggler-mobile').css('display') !== 'none';
    var timer;

    $('#search-overlay input.search-field').each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        let debounceSuggestions = debounce(getSuggestions, 300);

        $(this).on('keyup click', function (e) {
            debounceSuggestions($(this).val(), searchTriggerEnum.INPUT, isMobileSearch, e);
        });
    });

    $('input.search-field').on('keydown', function (e) {
        validateInput(e);
    });

    /**
     * Triggers the AjaxCall only if the mouse remains on the button for at least 500ms
     */
    $('#search-overlay').on({
        mouseover: function () {
            // trigger if mouse hover for at least 500ms
            var $selector = $(this);
            timer = setTimeout(function () {
                if ($selector.data('value') && !$selector.hasClass('selected')) {
                    getSuggestions($selector.data('value'), searchTriggerEnum.BUTTON, isMobileSearch);
                    $('#search-overlay .results').find('.selected').each(function (index, element) {
                        if ($(element).hasClass('selected')) {
                            $(element).removeClass('selected');
                        }
                    });

                    $selector.addClass('selected');
                }
            }, 500);
        },
        mouseout: function () {
            // do not trigger if mouse hover less then 500ms
            clearTimeout(timer);
        }
    }, '.results .result');

    /**
     * Search open/close toggler
     */
    $('nav .search-toggler').on('click', function (e) {
        if (isSearchOpen()) {
            closeSearch();
        } else {
            openSearch();
            getSuggestions($('input.search-field').val(), searchTriggerEnum.INPUT, isMobileSearch);
        }
    });

    /**
     * Close search button
     */
    $('.site-search .closeSearch').on('click', function (e) {
        closeSearch();
    });

    /**
     * Close search if the user clicks on the blur background
     */
    $('.site-search').on('click', function (e) {
        if (isSearchOpen() && (e.target.className === 'site-search')) {
            closeSearch();
        }
    });

    $('.search-toggler').on('click', function (e) {
        const $search = $('.search-bar');
        $search.find('input').trigger('focus');
    });
};
